class Property {
  constructor(
    uuid,
    internalName,
    marketingName,
    country,
    state,
    city,
    address,
    zipcode,
    { address2, checkin, checkout, timezone, manualURL, favorite } = {}
  ) {
    this.uuid = uuid
    this.internalName = internalName
    this.marketingName = marketingName
    this.country = country
    this.state = state
    this.city = city
    this.address = address
    this.address2 = address2
    this.zipcode = zipcode
    this.manualURL = manualURL
    this.checkin = checkin
    this.checkout = checkout
    this.manualURL = manualURL
    this.timezone = timezone
    // this.images = "https://firebasestorage.googleapis.com/v0/b/rentalios-jonajo.appspot.com/o/defaultProperty.png?alt=media&token=3c3ae75c-9073-4bd9-a32b-981faafecf72"
    this.rooms = []
    this.favorite = favorite
  }
  setRooms(rooms = []) {
    this.rooms = rooms
  }
  setImage(images) {
    this.images = images
  }
  setContacts(contacts = []) {
    this.contactList = contacts
  }
  setFeatureImage(index) {
    this.featureImage = index
  }
}
export default Property
